<template>
  <aside :class="{ hid: !toggled }" class="sidebar" key="open_sidebar">
    <MobileTogglers
      :toggled="toggled"
      :fullscreen="fullscreen"
      @goFullscreen="$emit('goFullscreen')"
      @confirm="$emit('confirm')"
      @toggleToggled="$emit('toggleToggled')"
    />
    <SidebarHeaderTitle />
    <SidebarItemsList />
  </aside>
</template>

<script>
import MobileTogglers from './MobileTogglers';
import SidebarHeaderTitle from './SidebarHeaderTitle';
import SidebarItemsList from './SidebarItemsList';

export default {
  name: 'SidebarLarge',
  props: {
    toggled: Boolean,
    fullscreen: Boolean,
  },
  components: {
    MobileTogglers,
    SidebarHeaderTitle,
    SidebarItemsList,
  },
};
</script>
